import { createReducer, on } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import ThankyouNotes from '../../modals/ThankyouNotes';
import * as ThankYouNotesActions from "./thankyou.notes.action";

export interface ThankyouState extends EntityState<ThankyouNotes> {
    hasNextPage: boolean;
    errorMessage?: string;
    isLoaded? : boolean;
}

export const adapter: EntityAdapter<ThankyouNotes> = createEntityAdapter<ThankyouNotes>({
});

const intialThankyouState: ThankyouState = adapter.getInitialState({
    hasNextPage: false,
    isLoaded: false
});

const _thankyouNotesReducer = createReducer(
    intialThankyouState,
    on(ThankYouNotesActions.thankYouNotesLoaded, (state, { notes, hasNextPage }) => {
        return adapter.addMany(notes, { ...state, hasNextPage, isLoaded : true });
    }),
    on(ThankYouNotesActions.thankYouNotesLoadingError, (state, { errorMessage }) => {
        return { ...state, hasNextPage: true, errorMessage, isLoaded : true };
    }),
    on(ThankYouNotesActions.thankYouNotesResetCompleted, (state, { notes, hasNextPage }) => {
        return adapter.setAll(notes, { ...state, hasNextPage });
    })
);

export function thankyouNotesReducer(state: ThankyouState | undefined, action: any): ThankyouState {
    return _thankyouNotesReducer(state, action);
}

export const {
    selectAll,
    selectEntities,
    selectIds,
    selectTotal
} = adapter.getSelectors();



